import { createUseStyles } from "react-jss";
import { colors } from "../../../styles/colors";
import { hoverOnly, reducedMotion } from "../../../styles/breakpoints";

const useStyles = createUseStyles((_) => ({
  menuItem: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    width: "100%",
    /* 44px keeps the row a comfortable tap target on touch screens. */
    minHeight: 44,
    padding: "0 10px",
    marginBottom: 6,
    borderRadius: 12,
    border: "none",
    /* Rendered as a <button>, so reset the UA styles. */
    background: "transparent",
    color: "inherit",
    font: "inherit",
    textAlign: "left",
    cursor: "pointer",
    position: "relative",
    transition: "background-color 150ms ease",
    [reducedMotion]: {
      transition: "none",
    },
    [hoverOnly]: {
      "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.85)",
      },
    },
    "&:active": {
      backgroundColor: colors.WHITE,
    },
  },

  /** Current page. Colour alone is not enough, so an accent bar is added. */
  active: {
    backgroundColor: colors.WHITE,
    color: colors.secondary,
    fontFamily: "Poppins-Bold",
    "&::before": {
      content: '""',
      position: "absolute",
      left: -12,
      top: "50%",
      transform: "translateY(-50%)",
      width: 4,
      height: 24,
      borderRadius: "0 4px 4px 0",
      backgroundColor: colors.WHITE,
    },
    [hoverOnly]: {
      "&:hover": {
        backgroundColor: colors.WHITE,
      },
    },
  },

  /** Centres the icon when the sidebar is in icon-only rail mode. */
  rail: {
    justifyContent: "center",
    padding: 0,
  },

  iconSlot: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    width: 24,
    height: 24,
  },

  /** Long labels ellipsise instead of wrapping and breaking row alignment. */
  labelSlot: {
    flex: "1 1 auto",
    minWidth: 0,
    overflow: "hidden",
    "& > div": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  },

  inverseMenu: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    width: "100%",
  },
}));

export default useStyles;
